import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import withReduxForm from './withReduxFormField'
import InputField from '../forms/input-field'
import { GridRow, GridCol } from '../grid/'
import CtaButton from '../buttons/cta-button'
import FlatButton from '../buttons/flat-button'
import Notification from '../notifications/notification'
import { normalizePhone } from '../../services/normalizations'

const LabelledInput = withReduxForm(InputField)

const ContactForm = props => {
  const {
    handleSubmit,
    handleCancel,
    submitting,
    submitFailed,
    pristine,
    theme,
    nameLabel,
    phoneLabel,
    faxLabel,
    emailLabel,
    cancelText,
    saveText,
    errorNameAndOneContactDataText
  } = props
  return (
    <form id='addContact' onSubmit={handleSubmit}>
      <Field
        name='name'
        id='contact-name'
        label={nameLabel}
        theme={theme}
        component={LabelledInput}
        autoFocus={true}
      />
      <Field
        name='phone'
        id='contact-phone'
        label={phoneLabel}
        theme={theme}
        type='text'
        component={LabelledInput}
        normalize={normalizePhone}
      />
      <Field
        name='fax'
        id='contact-fax'
        label={faxLabel}
        theme={theme}
        type='text'
        component={LabelledInput}
        normalize={normalizePhone}
      />
      <Field
        name='email'
        id='contact-email'
        label={emailLabel}
        theme={theme}
        type='email'
        component={LabelledInput}
      />
      {submitFailed && (
        <Notification status='error' iconName='warning' hasIcon>
          {errorNameAndOneContactDataText}
        </Notification>
      )}
      <GridRow className='bottom-space top-space'>
        <GridCol type='one-half'>
          <FlatButton
            text={cancelText}
            type='button'
            onClick={handleCancel}
            disabled={submitting}
          />
        </GridCol>
        <GridCol type='one-half pull-right'>
          <CtaButton
            hasIcon={false}
            text={saveText}
            type='submit'
            disabled={pristine || submitting}
            isLoading={submitting}
          />
        </GridCol>
      </GridRow>
    </form>
  )
}

ContactForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleCancel: PropTypes.func,
  submitting: PropTypes.bool,
  submitFailed: PropTypes.bool,
  pristine: PropTypes.bool,
  theme: PropTypes.oneOf(['dark-theme', 'light-theme']),
  nameLabel: PropTypes.string,
  phoneLabel: PropTypes.string,
  faxLabel: PropTypes.string,
  emailLabel: PropTypes.string,
  cancelText: PropTypes.string,
  saveText: PropTypes.string,
  errorNameAndOneContactDataText: PropTypes.string
}

export default ContactForm



// WEBPACK FOOTER //
// ./src/ui/forms/contact-form.js